<form [formGroup]="categoryForm" (submit)="onSubmit()">
  <app-input-wrapper>
    <label>Category Name <span>*</span></label>
    <input
      type="text"
      placeholder="Category"
      inNoWhitespace
      formControlName="name"
      maxlength="100"
    />
    <span
      *ngIf="categoryForm.get('name')?.errors?.['required']&&(categoryForm.get('name')?.dirty||categoryForm.get('name')?.touched)"
    >
      Category is required
    </span>
  </app-input-wrapper>
  <app-input-wrapper>
    <label>Page Title <span>*</span></label>
    <input
      type="text"
      formControlName="pageTitle"
      placeholder="Page Title"
      inNoWhitespace
      maxlength="100"
    />
    <span
      *ngIf="categoryForm.get('pageTitle')?.errors?.['required']&&(categoryForm.get('pageTitle')?.dirty||categoryForm.get('pageTitle')?.touched)"
    >
      Page Title is required
    </span>
  </app-input-wrapper>
  <div class="blog-action__footer flex justify-end">
    <app-button
      customClass="outline"
      label="cancel"
      type="button"
      (action)="handleClose()"
    >
    </app-button>
    <app-button
      type="submit"
      [label]="editCategory ? 'Update' : 'Submit'"
      [isDisabled]="isLoading || initialLoading"
    >
      <app-button-loader *ngIf="isLoading" postfixContent></app-button-loader>
    </app-button>
  </div>
</form>
